import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api, mediaUrl } from "@/lib/api";
import { Reveal } from "./Reveal";

const vclass = (i) =>
  i === 0 ? "col-span-2 row-span-2" : i % 6 === 2 ? "col-span-2" : i % 3 === 1 ? "row-span-2" : "";

export const DynamicGallery = ({ section, id, testid, heading, subtitle, quote, hideIfEmpty }) => {
  const [photos, setPhotos] = useState(null);

  useEffect(() => {
    api.get(`/photos?section=${section}`).then((r) => setPhotos(r.data)).catch(() => setPhotos([]));
  }, [section]);

  if (hideIfEmpty && photos && photos.length === 0) return null;

  return (
    <section id={id} data-testid={testid} className="px-5 sm:px-8 lg:px-12 py-20 sm:py-28">
      <Reveal className="mb-12 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <h2 className="font-serif tracking-tightest text-4xl sm:text-6xl leading-[1.0] text-navy">{heading}</h2>
        {subtitle && <p className="max-w-sm text-lg text-navy-soft">{subtitle}</p>}
      </Reveal>

      <div className="grid grid-flow-dense grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4 auto-rows-[44vw] sm:auto-rows-[30vw] lg:auto-rows-[16vw]">
        {(photos || []).map((p, i) => (
          <motion.figure
            key={p.id}
            initial={{ opacity: 0, scale: 0.95, y: 24 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative overflow-hidden rounded-[1.5rem] glass p-2 ${vclass(i)}`}
            data-testid={`${testid}-item-${i}`}
          >
            <div className="relative h-full w-full overflow-hidden rounded-[1.15rem]">
              <img
                src={mediaUrl(p.src)}
                alt={`Le Cosplay Singers dal vivo ai comics — ${heading}`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
              />
              {quote && i === 0 && (
                <>
                  <div className="absolute inset-x-0 bottom-0 h-3/5 bg-gradient-to-t from-navy/70 to-transparent" />
                  <figcaption className="absolute inset-x-0 bottom-0 p-5 sm:p-8">
                    <p className="max-w-xl font-serif italic text-xl sm:text-3xl leading-tight text-white text-balance">
                      “{quote}”
                    </p>
                  </figcaption>
                </>
              )}
            </div>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
